import React, { ReactNode, useCallback, useMemo, useState } from "react";

interface GlobalErrorContextValue {
	errorCause?: Error;
	errorMessage?: string;

	clearError: () => void;
	setError: (message: string, cause?: Error) => void;
}

const defaultValue: GlobalErrorContextValue = {
	clearError: () => {},
	setError: () => {},
};

export const GlobalErrorContext = React.createContext<GlobalErrorContextValue>(defaultValue);

interface Props {
	children?: ReactNode;
}

export function GlobalErrorContextProvider(props: Props) {
	const [errorCause, setErrorCause] = useState<Error | undefined>();
	const [errorMessage, setErrorMessage] = useState<string>("");

	const clearError = useCallback(() => {
		setErrorCause(undefined);
		setErrorMessage("");
	}, []);

	const setError = useCallback((message: string, cause?: Error) => {
		setErrorCause(cause);
		setErrorMessage(message);
	}, []);

	const value = useMemo(() => {
		return {
			errorCause,
			errorMessage,

			clearError,
			setError,
		};
	}, [errorMessage, errorCause, clearError, setError]);

	return (
		<GlobalErrorContext.Provider value={value}>{props.children}</GlobalErrorContext.Provider>
	);
}
